var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJcb = function SvgJcb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -48.41,
    y1: 18.1,
    x2: -45.73,
    y2: 18.1,
    gradientTransform: "translate(112.61 47.73) scale(2.05 -2.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -48.41,
    y1: 18.52,
    x2: -45.73,
    y2: 18.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -48.41,
    y1: 18.97,
    x2: -45.73,
    y2: 18.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -54.41,
    y1: 18.52,
    x2: -51.69,
    y2: 18.52,
    gradientTransform: "translate(112.61 47.73) scale(2.05 -2.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#004e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0066b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -51.42,
    y1: 18.52,
    x2: -48.78,
    y2: 18.52,
    gradientTransform: "translate(112.61 47.73) scale(2.05 -2.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#be1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#dc0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60039"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6325",
    className: "cls-2",
    d: "m20,14.37c0,1.71-1.39,3.11-3.11,3.11H0V5.18c0-1.71,1.39-3.11,3.11-3.11h16.89v12.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6338",
    className: "cls-1",
    d: "m14.5,11.22h1.28s.12-.01.16-.01c.24-.05.45-.27.45-.57s-.21-.51-.45-.57c-.04-.01-.11-.01-.16-.01h-1.28v1.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6349",
    className: "cls-5",
    d: "m15.64,3.11c-1.22,0-2.22.99-2.22,2.22v2.31h3.14c.07,0,.16,0,.22.01.71.04,1.23.4,1.23,1.04,0,.5-.35.93-1.01,1.01v.02c.72.05,1.27.45,1.27,1.08,0,.67-.61,1.11-1.42,1.11h-3.45v4.52h3.26c1.22,0,2.22-.99,2.22-2.22V3.11h-3.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6360",
    className: "cls-3",
    d: "m16.23,8.84c0-.29-.21-.49-.45-.53-.02,0-.09-.01-.12-.01h-1.16v1.08h1.16s.11,0,.12-.01c.24-.04.45-.23.45-.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6371",
    className: "cls-4",
    d: "m3.34,3.11c-1.22,0-2.22.99-2.22,2.22v5.49c.62.31,1.27.5,1.92.5.77,0,1.19-.46,1.19-1.1v-2.59h1.91v2.58c0,1-.62,1.82-2.74,1.82-1.28,0-2.29-.28-2.29-.28v4.68h3.26c1.22,0,2.22-.99,2.22-2.22V3.11s-3.25,0-3.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6384",
    className: "cls-6",
    d: "m9.49,3.11c-1.22,0-2.22.99-2.22,2.22v2.91c.56-.48,1.54-.78,3.12-.71.84.04,1.75.27,1.75.27v.94c-.45-.23-.99-.44-1.69-.49-1.2-.09-1.92.5-1.92,1.53s.72,1.63,1.92,1.53c.7-.05,1.23-.27,1.69-.49v.94s-.89.23-1.75.27c-1.58.07-2.56-.23-3.12-.71v5.13h3.26c1.22,0,2.22-.99,2.22-2.22V3.11s-3.26,0-3.26,0Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJcb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jcb.da210517.svg";
export { ForwardRef as ReactComponent };